/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_Select_TitleInputs */

const en_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select new state`)
};

const fr_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un nouvel etat`)
};

const de_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Staat auswählen`)
};

const it_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un nuovo stato`)
};

const ru_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите новый штат`)
};

const es_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar nuevo estado`)
};

const zh_cn2_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择新状态`)
};

const ja_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい状態を選択`)
};

const hi_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया राज्य चुनें`)
};

const pt_pt2_explorer_info_state_select_title = /** @type {(inputs: Explorer_Info_State_Select_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o novo estado`)
};

/**
* | output |
* | --- |
* | "Select new state" |
*
* @param {Explorer_Info_State_Select_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_select_title = /** @type {((inputs?: Explorer_Info_State_Select_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Select_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_state_select_title(inputs)
	if (locale === "de") return de_explorer_info_state_select_title(inputs)
	if (locale === "it") return it_explorer_info_state_select_title(inputs)
	if (locale === "ru") return ru_explorer_info_state_select_title(inputs)
	if (locale === "es") return es_explorer_info_state_select_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_state_select_title(inputs)
	if (locale === "ja") return ja_explorer_info_state_select_title(inputs)
	if (locale === "hi") return hi_explorer_info_state_select_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_state_select_title(inputs)
	return en_explorer_info_state_select_title(inputs)
});